import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

const IconStyle = styled.span`
    color: var(--biscay);
`;

const StyledPopover = styled(Popover)`
    border-color: var(--biscay);

    &.popover {
        &.right {
            .arrow {
                border-right-color: var(--biscay);
            }
        }

        &.left {
            .arrow {
                border-left-color: var(--biscay);
            }
        }

        &.top {
            .arrow {
                border-top-color: var(--biscay);
            }
        }

        &.bottom {
            .arrow {
                border-bottom-color: var(--biscay);
            }
        }
    }

    .popover-body {
        color: var(--biscay);
    }
`;

const PopoverTooltip = ({ icon, tooltipContent, tooltipId }) => {
    return (
        <OverlayTrigger
            overlay={
                <StyledPopover id={tooltipId}>
                    <Popover.Content>{tooltipContent}</Popover.Content>
                </StyledPopover>
            }
        >
            <IconStyle data-testid={tooltipId}>{icon}</IconStyle>
        </OverlayTrigger>
    );
};

PopoverTooltip.propTypes = {
    icon: PropTypes.node,
    tooltipContent: PropTypes.node.isRequired,
    tooltipId: PropTypes.string.isRequired,
};
PopoverTooltip.defaultProps = {
    icon: <FaInfoCircle />,
};

export default PopoverTooltip;
